
import  axios  from 'axios';
import {
    CLEAR_A_TOWJOB_ERROR_MESSAGE,
    clearTowErrorMsgInStore,
    loadTowjobDataInStore,
    SET_TOW_CLEAR_ALL_FILTER
} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
//import {clearTowAllFiltersInStore, SET_TOW_CLEAR_ALL_FILTER} from "../towjob/actions";


export const LOAD_DISPATCHSHEET_DATA = 'dispatchsheet/LOAD_DISPATCHSHEET_DATA';
export const DELETE_A_DISPATCHSHEET = 'dispatchsheet/DELETE_A_DISPATCHSHEET';
export const SAVE_A_DISPATCHSHEET = 'dispatchsheet/SAVE_A_DISPATCHSHEET';
export const UPDATE_A_DISPATCHSHEET = 'dispatchsheet/UPDATE_A_DISPATCHSHEET';
export const UPDATE_A_DISPATCHSHEET_PATH = 'dispatchsheet/UPDATE_A_DISPATCHSHEET_PATH';
export const SET_DISPATCHSHEET_STATUS_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_STATUS_FILTER';
export const SET_DISPATCHSHEET_PONUMBER_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_PONUMBER_FILTER';
export const SET_DISPATCHSHEET_VIN_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_VIN_FILTER';
export const SET_DISPATCHSHEET_PLATE_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_PLATE_FILTER';
export const SET_DISPATCHSHEET_LOCATION_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_LOCATION_FILTER';
export const SET_DISPATCHSHEET_STARTTIME_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_STARTTIME_FILTER';
export const SET_DISPATCHSHEET_ENDTIME_FILTER = 'dispatchsheet/SET_DISPATCHSHEET_ENDTIME_FILTER';
export const SET_DISPATCHSHEET_CLEAR_ALL_FILTER = 'dispatchsheet/SET_DISPATCH_CLEAR_ALL_FILTER';
export const CLEAR_A_DISPATCH_ERROR_MESSAGE = 'dispatchsheet/CLEAR_A_DISPATCH_ERROR_MESSAGE';






export function clearDispatchErrorMsgInStore(){
    return {
        type: CLEAR_A_DISPATCH_ERROR_MESSAGE,
        
    }
}

export function loadDispatchsheetDataInStore(argDispatchsheetDataArray) {
    return {
        type: LOAD_DISPATCHSHEET_DATA,
        dispatchsheetsData:argDispatchsheetDataArray
    }
}
export function deleteADispatchsheetInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_DISPATCHSHEET,
        deleteDispatchsheetResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveADispatchsheetDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_DISPATCHSHEET,
        saveDispatchsheetResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateADispatchsheetDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_DISPATCHSHEET,
        updateDispatchsheetResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function getADispatchsheetPathInStore(argFilePath , argErrorMsg) {
    return {
        type: UPDATE_A_DISPATCHSHEET_PATH,
        filePath:argFilePath,
        errorMsg:argErrorMsg
    }
}


//Filter calls in Store
export function setDispatchStatusFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_STATUS_FILTER,
        dispatchStatusFilter:argFilter,
    }
}

export function setDispatchPonumberFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_PONUMBER_FILTER,
        dispatchPonumberFilter:argFilter,
    }
}

export function setDispatchVinFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_VIN_FILTER,
        dispatchVinFilter:argFilter,
    }
}

export function setDispatchPlateFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_PLATE_FILTER,
        dispatchPlateFilter:argFilter,
    }
}


export function setDispatchLocationFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_LOCATION_FILTER,
        dispatchLocationFilter:argFilter,
    }
}

export function setDispatchStartTimeFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_STARTTIME_FILTER,
        dispatchStartTimeFilter:argFilter,
    }
}

export function setDispatchEndTimeFilterInStore(argFilter ) {
    return {
        type: SET_DISPATCHSHEET_ENDTIME_FILTER,
        dispatchEndTimeFilter:argFilter,
    }
}

export function clearDispatchAllFiltersInStore() {
    return {
        type: SET_DISPATCHSHEET_CLEAR_ALL_FILTER,
        
    }
}



/********************* End of InStore calls **************************/

//****************************************
//Add Dispatch to the TowJobs Array
//****************************************
export function addDispatchToDispatchsArray(argDispatch) {
    return (dispatch, getState) => {
        const state = getState();
        let tempDispatchArray=[] ;
        tempDispatchArray = Object.assign(tempDispatchArray,state.dispatchsheet.dispatchsheetsArray);
        //adding to the top of the array.
        tempDispatchArray.unshift(argDispatch);
       
        dispatch(loadDispatchsheetDataInStore(tempDispatchArray));
    }//end of return
}

//****************************************
//Delete TowJob from the TowJobs Array
//****************************************
export function deleteDispatchFromDispatchsArray(argDispatchId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempDispatchArray=[] ;
        tempDispatchArray = Object.assign(tempDispatchArray,state.dispatchsheet.dispatchsheetsArray);
        //removig the match element with the matching id.
        let newArray = tempDispatchArray.filter(element => { return element.id != argDispatchId });
        
        dispatch(loadDispatchsheetDataInStore(newArray));
    }//end of return
}
//****************************************
//update TowJob in the TowJobs Array
//****************************************
export function updateDispatchInDispatchsArray(argDispatch ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempDispatchArray=[] ;
        tempDispatchArray = Object.assign(tempDispatchArray,state.dispatchsheet.dispatchsheetsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempDispatchArray.filter(element => { return element.id != argDispatch.id });
        //adding to the top of the array.
        newArray.unshift(argDispatch);
        dispatch(loadDispatchsheetDataInStore(newArray));
    }//end of return
}


export function clearDispatchErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearDispatchErrorMsgInStore());
    }
}

///users/{userid}/companies/{companyid}/towjobs/{jobid}/dispatchsheets/show

export function updateADispatchsheetPath(argURL, argCompanyId, argJobId ) {


    /*var pathURL = argURL+"users/"+state.user.saveUserResp.id+"/companies/"+argCompanyId+"/towjobs/"+argJobId+"/dispatchsheets/show";

    return pathURL*/
   return (dispatch, getState) => {
        const state = getState();

        var pathURL = argURL+"users/"+state.user.saveUserResp.id+"/companies/"+argCompanyId+"/dispatchlogs/"+argJobId+"/show";

                console.log("The path is " + pathURL);
                dispatch(getADispatchsheetPathInStore(pathURL, {}));


    }//end of return
}
//****************************************
//Below is for update a Stream
//****************************************
export function updateADispatchsheet(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateADispatchsheetOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateADispatchsheetDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error updating a dispatch sheet" +  err.response.statusText + err.response.status);
            dispatch(updateADispatchsheetDataInStore({}, errorObj));
        });
    }//end of return
}


function updateADispatchsheetOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateADispatchsheet(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on updating a dispatch sheet " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateADispatchsheet(argURL, argDispatchsheet,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/dispatchlogs" ;
    console.log(" on posting a dispatchsheet the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argDispatchsheet,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveADispatchsheet(argURL, argDispatchsheetInfo, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveADispatchsheetOnServer(argURL, argDispatchsheetInfo, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveADispatchsheetDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error saving a dispatch log" + err.response.statusText + err.response.status);
            dispatch(saveADispatchsheetDataInStore({}, errorObj));
        });
    }//end of return
}


function saveADispatchsheetOnServer( argURL, argDispatchsheetInfo, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveADispatchsheet(argURL, argDispatchsheetInfo, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a dispatchsheet " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveADispatchsheet(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/dispatchlogs";
    console.log(" on posting a dispatchsheet the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteADispatchsheet(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteADispatchsheetOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteADispatchsheetInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteADispatchsheetInStore({}, errorObj));
        });
    }//end of return
}


function deleteADispatchsheetOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteADispatchsheet(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a Dispatchsheet " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteADispatchsheet(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/dispatchlogs/"+argStorageId;
    console.log(" on deleteing a Dispatchsheet the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of Dispatch Sheet

export function loadDispatchsheetsData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfDispatchsheets(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadDispatchsheetDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfDispatchsheets(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/dispatchlogs";
    console.log(" on getting list of Dispatchsheets  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfDispatchsheets( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfDispatchsheets(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


//Get list of Dispatch Sheet with filters

export function loadDispatchsheetsDataWithFilter(argURL, argCompanyId, argFilter) {
    return (dispatch, getState) => {
        const state = getState();
        console.log("loadDispatchsheetsDataWithFilter")
        console.log(state.user.saveUserResp.id)
        getListOfDispatchsheetsWithFilter(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id, argFilter).then(function(companysList){
            
            dispatch(loadDispatchsheetDataInStore(companysList));
            
        }, function(err){
            console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
function getListOfDispatchsheetsWithFilter( argURL, argCompanyId ,argIdToken, argUserId, argFilter ){
    
    var returnPromise = new Promise(function(resolve, reject){
        
        var arrayOfGets = [];
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfDispatchsheetsWithFilter(argURL, argCompanyId ,argIdToken, argUserId, argFilter )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    
    return returnPromise;
}

function getArrayOfGetsForListOfDispatchsheetsWithFilter(argURL,argCompanyId ,argIdToken, argUserId, argFilter  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */
    
    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/dispatchlogs"+argFilter;
    console.log(" on getting list of Dispatchsheets  the URL is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

export function setDispatchStatusFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchStatusFilterInStore(argStatus));
    }
}


export function setDispatchPonumberFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchPonumberFilterInStore(argStatus));
    }
}

export function setDispatchVinFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchVinFilterInStore(argStatus));
    }
}

export function setDispatchPlateFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchPlateFilterInStore(argStatus));
    }
}

export function setDispatchLocationFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchLocationFilterInStore(argStatus));
    }
}

export function setDispatchStartTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchStartTimeFilterInStore(argStatus));
    }
}
export function setDispatchEndTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setDispatchEndTimeFilterInStore(argStatus));
    }
}

export function clearDispatchAllFilters(){
    return (dispatch) => {
        dispatch(clearDispatchAllFiltersInStore());
    }
}


